// src/components/features/Elevation/components/ElevationStep4StaircaseGlass.jsx
// Staircase Glass / Window Pattern — (folder "5.Staircase pattern full
// glass or window pattern radio" — "Radio" naam hai, isliye radio /
// single-select UI hi rakha gaya hai)

import ElevationRadioStep from "./shared/ElevationRadioStep";
import { STAIRCASE_GLASS_WINDOW_IMAGES } from "../../../../assets/Elevation/elevationAssets";

const OPTIONS = STAIRCASE_GLASS_WINDOW_IMAGES.map((img) => ({ ...img, sub: undefined }));

export default function ElevationStep4StaircaseGlass(props) {
  return (
    <ElevationRadioStep
      {...props}
      title="Staircase Glass / Window Pattern"
      subtitle="Select the glass / window pattern style for your staircase area"
      options={OPTIONS}
      fieldKey="elevationStaircaseGlass"
    />
  );
}
